// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../styled-components/dark';
import { getColorFromPercentage } from '../../utils/color';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const PercentDistributionCompletenessClassName = 'percent-distribution-completeness';
const Completeness = styled.span`
  flex: 1;
  margin: 0 8px 0 0;

  font-weight: 600;
  font-style: normal;
  font-size: 0.7em;
  color: ${theme.PercentDistribution.color};
`;

export const PercentDistributionBackgroundBarClassName = 'percent-distribution-background-bar';
const BarWrapper = styled.div`
  flex: 5;
  background-color: ${theme.PercentDistribution.backgroundColor};
`;

const Bar = styled.div`
  height: 1px;
  border-radius: 2px;
  transition: all 300ms ease-in-out;
  opacity: 1;
  ${({ $width, $hasColor, $height }) => {
    if (typeof $width !== 'undefined') {
      return css`
        width: ${$width}%;
        background-color: ${$hasColor ? getColorFromPercentage(parseFloat($width)) : theme.PercentDistribution.white};
        height: ${$height}px;
      `;
    } else {
      return css`
        width: auto;
        background-color: transparent;
        height: ${$height}px;
      `;
    }
  }}
`;

type PropsType = {
  completeness: number;
  className?: string;
  height: number;
  hasColor?: boolean;
  showLabel?: boolean;
  showCompleteness?: boolean;
};

const PercentDistribution = ({
  completeness,
  className,
  height,
  hasColor = false,
  showLabel = true,
  showCompleteness = false,
}: PropsType) => {
  const label: string = useMemo(() => (completeness ? `${completeness}%` : '-'), [completeness]);
  const hasCompleteness = useMemo(() => completeness || showCompleteness, [completeness, showCompleteness]);

  return (
    <Wrapper className={className}>
      {showLabel ? <Completeness className={PercentDistributionCompletenessClassName}>{label}</Completeness> : null}
      {hasCompleteness ? (
        <BarWrapper className={PercentDistributionBackgroundBarClassName}>
          <Bar $width={completeness} $height={height} $hasColor={hasColor} />
        </BarWrapper>
      ) : null}
    </Wrapper>
  );
};

export default PercentDistribution;
